import { VerifyEmailInput } from "../types";
import { AxiosStatic } from "axios";

const verifyEmail =
  (serverURL: string, appAxios: AxiosStatic) =>
  async ({ email, token }: VerifyEmailInput): Promise<void> => {
    return await appAxios.post(
      `${serverURL}/auth/verify-email`,
      {
        email,
        token,
      },
      { withCredentials: true }
    );
  };

export default verifyEmail;
